import { render, staticRenderFns } from "./EditarLicencia.vue?vue&type=template&id=3067b580&"
import script from "./EditarLicencia.vue?vue&type=script&lang=js&"
export * from "./EditarLicencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports